"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/auth-level.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fauth-level.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.authLevelToJSON = exports.authLevelFromJSON = exports.AuthLevel = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.auth.proto';
/**
 * The numbers for this enum correspond to a numerical value for the level.
 * These are preserved from the original enum for backwards compatibility.
 */
var AuthLevel;
(function (AuthLevel) {
    /**
     * RESTRICTED - User is partially authenticated and may perform verification operations.
     */
    AuthLevel["RESTRICTED"] = "RESTRICTED";
    /**
     * LOW - User is authenticated.
     */
    AuthLevel["LOW"] = "LOW";
    /**
     * STRONG - User is strongly authenticated.
     */
    AuthLevel["STRONG"] = "STRONG";
    AuthLevel["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AuthLevel || (exports.AuthLevel = AuthLevel = {}));
function authLevelFromJSON(object) {
    switch (object) {
        case 0:
        case 'RESTRICTED':
            return AuthLevel.RESTRICTED;
        case 1:
        case 'LOW':
            return AuthLevel.LOW;
        case 2:
        case 'STRONG':
            return AuthLevel.STRONG;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AuthLevel.UNRECOGNIZED;
    }
}
exports.authLevelFromJSON = authLevelFromJSON;
function authLevelToJSON(object) {
    switch (object) {
        case AuthLevel.RESTRICTED:
            return 'RESTRICTED';
        case AuthLevel.LOW:
            return 'LOW';
        case AuthLevel.STRONG:
            return 'STRONG';
        case AuthLevel.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.authLevelToJSON = authLevelToJSON;
//# sourceMappingURL=auth-level.js.map